import { render } from "./supplier-login.html?vue&type=template&id=e5522d42&scoped=true&ts=true"
import script from "./SupplierLogin.vue?vue&type=script&lang=ts"
export * from "./SupplierLogin.vue?vue&type=script&lang=ts"

import "./supplier-login.scss?vue&type=style&index=0&id=e5522d42&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5522d42"]])

export default __exports__